// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"886d9a70","293":"f2d23c0a"}[chunkId] + ".chunk.js";
};